import easyfyAxios from '@shared/easyfy.axios';

export const GetReceipt = async (orderNumber: string, checkoutid: string): Promise<any> => {
  return await easyfyAxios.get(`/receipt?handler=receipt&orderNumber=${orderNumber}&checkoutId=${checkoutid}`);
};

export const GetReceiptErrorPage = async (isAgeVerification: boolean): Promise<any> => {
  return await easyfyAxios.get(`/receipt?handler=receiptErrorPage&isAgeVerification=${isAgeVerification}`);
};
